import React from "react";
import { isDualPanelManagerV3Enabled } from "MessagingV2/modules/Utils";
import { CohortListSkeleton } from "AppComponents/DualPanelManageMembersV2";
import DualPanelQueryWrapper, {
  metadataPropsV2,
} from "./DualPanelQueryWrapper";
import DualPanelQueryWrapperV3, {
  metadataPropsV3,
} from "./DualPanelQueryWrapperV3";

export const getDualPanelQueryWrapperConfig = () => {
  const isDualPanelV3Enabled = isDualPanelManagerV3Enabled();
  const QueryWrapper = isDualPanelV3Enabled
    ? DualPanelQueryWrapperV3
    : DualPanelQueryWrapper;
  return {
    metadata: isDualPanelV3Enabled ? metadataPropsV3 : metadataPropsV2,
    renderQueryWrapper: queryProps => (
      <QueryWrapper
        {...queryProps}
        customLoadingComponent={<CohortListSkeleton />}
        showLoadingIcon={false}
      />
    ),
  };
};
